var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9224 0.539551C11.2779 0.40625 11.6778 0.40625 12.0332 0.539551L21.9864 4.80518C22.6084 5.07178 22.9639 5.73828 22.8306 6.40479C22.6973 7.07129 22.1197 7.51562 21.4087 7.51562V7.87109C21.4087 8.49316 20.9644 8.9375 20.3423 8.9375H2.56887C1.99124 8.9375 1.50247 8.49316 1.50247 7.87109V7.51562C0.835963 7.51562 0.258326 7.07129 0.125025 6.40479C-0.00827546 5.73828 0.347193 5.07178 0.969264 4.80518L10.9224 0.539551ZM11.5 6.09375C12.2554 6.09375 12.9219 5.47168 12.9219 4.67188C12.9219 3.9165 12.2554 3.25 11.5 3.25C10.7002 3.25 10.0781 3.9165 10.0781 4.67188C10.0781 5.47168 10.7002 6.09375 11.5 6.09375ZM5.76809 18.8906H7.54543V10.3594H10.3892V18.8906H12.5664V10.3594H15.4102V18.8906H17.1875V10.3594H20.0313V19.1128C20.0313 19.1128 20.0757 19.1128 20.0757 19.1572L22.2085 20.5791C22.7417 20.9346 22.9639 21.5566 22.7862 22.1787C22.6084 22.7563 22.0752 23.1562 21.4532 23.1562H1.50247C0.880396 23.1562 0.347193 22.7563 0.169459 22.1787C-0.00827546 21.5566 0.213893 20.9346 0.747096 20.5791L2.87991 19.1572C2.87991 19.1128 2.92434 19.1128 2.92434 19.1128V10.3594H5.76809V18.8906Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAch);
export default __webpack_public_path__ + "static/media/ACH.d8dcea79fb930b682e01f9a54f73bdd0.svg";
export { ForwardRef as ReactComponent };